<template>
	<div v-if="greeting && template">
		<h2 v-if="template === 'nameFirst'">
			<span class="capitalize" v-if="user.firstname">{{ user.firstname }} </span><span>{{ greeting() }}</span>
		</h2>
		<h2 v-if="template === 'noName'">
			<span>{{ greeting() }}</span>
		</h2>
		<h2 v-if="template === 'nameEnd'"  :style="!$mq.isDesktop() ? 'font-size: 20px' : ''">
			<span>{{ greeting() }}</span><span class="capitalize" v-if="user.firstname"> {{ user.firstname }}</span>
		</h2>
	</div>
</template>

<script>
const moment = require('moment')

export default {
	data () {
		return {
			template: 'nameEnd'
		}
	},

	computed: {
		user () {
			return this.$root.user
		}
	},

	methods: {
		greeting () {
			var date = moment().date()
			var month = moment().month() + 1

			var holiday
			if (date === 25 && month === 12) holiday = 'Buon Natale'
			if (date === 1 && month === 1) holiday = 'Buon Anno'
			if (date === 14 && month === 2) holiday = 'Quomi loves you'
			if (holiday) {
				this.template = 'nameEnd'
				return holiday
			}

			var season
			if (date === 21 && month === 3) season = 'Benvenuta Primavera!'
			if (date === 21 && month === 6) season = 'Sentiamo profumo di ferie!'
			if (date === 21 && month === 9) season = 'Caldarroste in arrivo!'
			if (date === 21 && month === 12) season = 'Sarà un bianco Natale?'
			if (season) {
				this.template = 'noName'
				return season
			}

			var halloween
			if (date === 31 && month === 10) halloween = 'dolcetto o scherzetto? 🎃'
			if (halloween) {
				this.template = 'nameFirst'
				return halloween
			}

			if (this.user && this.user.subscription && this.user.subscription.is_suspended) {
				this.template = 'nameEnd'
				return 'Che bello rivederti'
			}

			if (this.user && this.user.order && this.user.subscription && this.user.subscription.orders_total === 1) {
				this.template = 'nameEnd'
				return 'Pronti per cucinare'
			}

			var time = moment().hours()
			var dayTime
			if (time > 0 && time <= 12) dayTime = 'Buongiorno'
			if (time > 12 && time < 17) dayTime = 'Buon pomeriggio'
			if (time >= 17) dayTime = 'Buonasera'
			if (dayTime) {
				this.template = 'nameEnd'
				return dayTime
			}
		}
	}
}

</script>

<style scoped>
	h2 {
		font-size: 32px;
		margin: 0;
	}
</style>
